import { render, staticRenderFns } from "./BlockRegistrationInformation.vue?vue&type=template&id=65fda437&"
import script from "./BlockRegistrationInformation.vue?vue&type=script&lang=ts&"
export * from "./BlockRegistrationInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports